import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import moment from 'moment';
import isNull from 'lodash/isNull';
import find from 'lodash/find';
import get from 'lodash/get';

import Switch from '../switch';
import Link from '../../../shared/link';

const propTypes = {
	row: PropTypes.object,
	statuses: PropTypes.array,
	priorities: PropTypes.array,
	pause: PropTypes.func,
	unpause: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	className: PropTypes.string,
	openCloseForm: PropTypes.func,
	requestQueryString: PropTypes.string
};

const Row = ({
	row,
	statuses,
	priorities,
	pause,
	unpause,
	intl,
	can,
	className,
	openCloseForm,
	requestQueryString
}) => {
	const closeTicketPermission = (process.env.CPA_ENV === 'rocket' && row.category === 'gift_order')
		? 'closeGiftOrderTicket'
		: 'closeTicket';

	return (
		<tr className={`${className} ${getRowStyle(statuses, row)}`}>
			<td className="datetime">
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span className="date">{moment(row.updated_at).format('DD.MM.YYYY')}</span>
					<span className="at">{intl('at')}</span>
					<span className="time">{moment(row.updated_at).format('HH:mm')}</span>
				</Link>
			</td>
			<td>
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span>
						{row.id}
					</span>
				</Link>
			</td>
			<td
				className={cn({
					title: true,
					title__closed: !!row.closed_at
				})}
			>
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					{
						row.category === 'gift_order' &&
							<span className = "gift-icon"></span>
					}
					<span className="title">
						{row.title}
					</span>
					{
						row.last_affiliate_post &&
							!row.last_affiliate_post.viewed_at &&
							!row.closed_at &&
							<span className="unread"></span>
					}
				</Link>
			</td>
			<td className="affiliate">
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span>
						{row.affiliate}
					</span>
				</Link>
			</td>
			<td className={getPriorityStyle(priorities, row)}>
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span>
						{row.priority}
					</span>
				</Link>
			</td>
			<td className="time">
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span>
						{formatThreadDate(row, intl)}
					</span>
				</Link>
			</td>
			<td className="email modify--left-border">
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span>
						{(row.last_answer && row.last_answer.admin) || '-'}
					</span>
				</Link>
			</td>
			<td className="email hide-less-1600">
				<Link to={`threads/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span>
						{row.manager || '-'}
					</span>
				</Link>
			</td>
			<td className="actions">
				{row.closed_at && row.rating == 0 && (<span className={`vote-button vote-down`} />)}
				{row.closed_at && row.rating == 1 && (<span className={`vote-button no-vote`} />)}
				{row.closed_at && row.rating == 2 && (<span className={`vote-button vote-up`} />)}
				{ can('answer') && !row.closed_at && (
					<Switch isActive={!row.paused_at} onSwitch={() => row.paused_at ? unpause(row.id) : pause(row.id)} />
				) }
				{can(closeTicketPermission) && !row.closed_at && (
					<span className="close-ticket" onClick={() => openCloseForm(row.id)} />
				)}
			</td>
		</tr>
	);
};

// functions
const formatThreadDate = (row, intl) => {
	switch (true) {
		case !isNull(row.paused_at):
			return intl('paused %s', moment.duration(moment(row.paused_at).diff()).humanize(true));
		case !isNull(row.closed_at):
			return intl('closed %s', moment.duration(moment(row.closed_at).diff()).humanize(true));
		case isNull(row.last_affiliate_post):
			return intl('created %s', moment.duration(moment(row.created_at).diff()).humanize(true));
		case isNull(row.last_answer) || moment(row.last_answer.created_at).isBefore(row.last_affiliate_post.created_at):
			return intl(
				'without answer for %s',
				moment.duration(moment(row.last_affiliate_post.created_at).diff()).humanize()
			);
		default:
			return intl(
				'answered %s',
				moment.duration(moment(row.last_answer.created_at).diff(row.last_affiliate_post.created_at)).humanize(true)
			);
	}
};

const getRowStyle = (statusesList, row) => {
	let style = [];
	let rowStatus = row.status;
	style.push(get(find(statusesList, status => status.id === rowStatus), 'id'));

	let isWithoutAnswer =
		isNull(row.last_answer) ||
		(!isNull(row.last_answer) &&
		!isNull(row.last_affiliate_post) &&
		moment(row.last_answer.created_at).isBefore(row.last_affiliate_post.created_at));

	let isLongWithoutAnswer =
		isWithoutAnswer &&
		!isNull(row.last_affiliate_post) &&
		Math.abs(moment.duration(moment(row.last_affiliate_post.created_at).diff()).asHours()) > 1;

	if (isLongWithoutAnswer) {
		style.push('long-without-answer');
	} else if (isWithoutAnswer) {
		style.push('without-answer');
	}

	return style.join(' ');
};

const getPriorityStyle = (priorities, row) => {
	return ['priority', get(find(priorities, priority => priority.value === row.priority), 'value')].join(' ');
};

Row.propTypes = propTypes;

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/table/row.js